module.exports = __webpack_public_path__ + "img/notice.a98af1d9.svg";